import { render, staticRenderFns } from "./HuePalette.vue?vue&type=template&id=27ab7176&scoped=true&"
import script from "./HuePalette.vue?vue&type=script&lang=js&"
export * from "./HuePalette.vue?vue&type=script&lang=js&"
import style0 from "./HuePalette.vue?vue&type=style&index=0&id=27ab7176&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ab7176",
  null
  
)

export default component.exports